import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-surface';

class RelatedOrgList extends LitEntity {
  constructor() {
    super();
    this.relatedOrgs = [];
  }

  static get properties() {
    return {
      relatedOrgs: { type: Array, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .header {
        margin: 0 var(--root-margin) var(--root-margin);
      }
      bn-surface {
        display: flex;
      }
      bn-surface:hover {
        background-color: var(--hover-color);
      }
      h3 {
        flex-grow: 1;
      }
      h1 {
        margin-left: 0;
      }
      p {
        margin-top: 0;
      }
      @media(max-width: 1000px) {
        bn-surface {
          flex-direction: column;
        }
      }
    `];
  }

  render() {
    return html`
      <div class="header">
        <h1>Customers</h1>
      </div>
      ${this.relatedOrgs.map((relation) => this._renderRelation(relation))}
    `;
  }

  _renderRelation(relation) {
    const org = relation.getSubEntityByClass('organization');
    const orgId = this.getHref('self', org);
    return html`
      <bn-surface .href="/related/show?orgId=${encodeURIComponent(orgId)}">
        <h3>${org.properties.name}</h3>
      </bn-surface>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.relatedOrgs = (this.entity && this.entity.getSubEntitiesByClass('related-organization')) || [];
  }
}

customElements.define('related-org-list', RelatedOrgList);
